import { isInteger } from "lodash"

/**
 * 郵便番号バリデーションチェック
 * @param {number} zipcode1 郵便番号前半
 * @param {number} zipcode2 郵便番号前半
 * @returns {boolean} チェック結果
 */
export function isValidZipcode(zipcode1, zipcode2) {
  if (!zipcode1 || !zipcode2) {
    return false
  }

  // 整数チェック
  // 文字列を*1で数値化してから検証する
  if (!Number.isInteger(zipcode1 * 1) || !Number.isInteger(zipcode2 * 1)) {
    return false
  }

  function digits(num) {
    return (num + '').length
  }

  if (digits(zipcode1) !== 3 || digits(zipcode2) !== 4) {
    return false
  }

  return true
}

/**
 * 誕生日入力欄の選択肢
 * @returns {array} 年一覧
 */
export function getBirthdayYears() {
  return range(1900, yearFromNow(-16)).reverse()
}

/**
 * 結婚記念日入力欄の選択肢
 * @returns {array} 年一覧
 */
export function getAnniversaryYears() {
  return range(1900, yearFromNow(5)).reverse()
}

/**
 * 一問一答で選択可能な年
 * @returns {array} 年一覧
 */
export function getQuestionYears() {
  return range(yearFromNow(-80), yearFromNow(3)).reverse()
}

export function getCurrentYear() {
  return (new Date()).getFullYear()
}

function yearFromNow(gap) {
  return getCurrentYear() + gap
}

export function range(from, to) {
  const res = []

  for (let i = from; i <= to; i++) {
    res.push(i)
  }

  return res
}

/**
 * お子様情報 誕生日入力欄の選択肢
 * @returns {array} 年一覧
 */
export function getChildBirthdayYears() {
    return range(1993, yearFromNow(0)).reverse()
}

/**
 * 金額にカンマを付与して取得
 * @param {number/string} price 金額
 * @param {boolean} isAllowMinus マイナス値を許容する デフォルト：true
 * @returns {string} カンマ付き金額
 */
export function getCommaPrice(price, maxAbsPrice, isAllowMinus = true) {
  let res = getCommaRemovedPrice(price, maxAbsPrice, isAllowMinus)
  return res.toLocaleString() // カンマ追加
}

/**
 * 金額のカンマを除去して取得
 * @param {number/string} price 金額
 * @param {number} maxAbsPrice 最大の絶対値
 * @param {boolean} isAllowMinus マイナス値を許容する デフォルト：true
 * @returns {string} カンマ無し金額
 */
export function getCommaRemovedPrice(price, maxAbsPrice, isAllowMinus = true) {
  price = String(price)
  let res = 0 // 初期値0

  if (price !== undefined) {
    let removed = ''
    if (isAllowMinus) {
      removed = price.replace(/,|[^-0-9]/g, '') // 不要な文字除去
    } else {
      removed = price.replace(/,|[^0-9]/g, '') // 不要な文字除去
    }
    const intPrice = parseInt(removed, 10) // 数値化

    if(!isNaN(intPrice) && isInteger(intPrice)) {
      if (Math.abs(intPrice) > maxAbsPrice) {
        // 最大の絶対値を超える場合
        if (intPrice > 0) {
          // 正数
          res = maxAbsPrice
        } else {
          // 負数
          res = maxAbsPrice * -1
        }
      } else {
        // Nanでない数字の場合、数字を返す
        // 0を足すことで、-0を0にする
        res = intPrice + 0
      }
    }
  }
  return res
}
